module.exports = __webpack_public_path__ + "img/330.c38da79d.jpg";